import React from 'react';
import Select from '../../../components/ui/Select';

const ExperienceVerification = ({ 
  seniorityLevel, 
  onSeniorityChange, 
  yearsOfExperience, 
  onYearsChange 
}) => {
  const seniorityOptions = [
    { value: 'senior', label: 'Senior Professional', description: '8-12 years experience' },
    { value: 'lead', label: 'Lead/Principal', description: '12-15 years experience' },
    { value: 'manager', label: 'Manager', description: '10+ years with team management' },
    { value: 'director', label: 'Director', description: '15+ years with strategic leadership' },
    { value: 'vp', label: 'VP/Executive', description: '18+ years with executive responsibility' }
  ];

  const experienceRanges = [
    { value: '8-10', label: '8-10 years' },
    { value: '10-12', label: '10-12 years' },
    { value: '12-15', label: '12-15 years' },
    { value: '15-18', label: '15-18 years' },
    { value: '18-20', label: '18-20 years' },
    { value: '20+', label: '20+ years' }
  ];

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        Experience Verification
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        BlinD is exclusively for senior professionals with 8+ years of experience
      </p>

      <div className="space-y-6">
        <Select
          label="Seniority Level"
          description="Select the level that best describes your current position"
          options={seniorityOptions}
          value={seniorityLevel}
          onChange={onSeniorityChange}
          required
        />

        <Select
          label="Total Years of Professional Experience"
          description="Count all relevant professional experience in your field"
          options={experienceRanges}
          value={yearsOfExperience}
          onChange={onYearsChange}
          required
        />

        <div className="p-4 md:p-6 rounded-xl bg-accent/10 border border-accent/20">
          <div className="flex gap-3">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center">
                <span className="text-lg">ℹ️</span>
              </div>
            </div>
            <div>
              <p className="text-sm md:text-base text-foreground font-medium mb-1">
                Why We Ask
              </p>
              <p className="text-sm md:text-base text-muted-foreground">
                BlinD focuses on senior passive talent to ensure high-quality matches. Your experience level helps us curate the most relevant exceptional opportunities for your profile.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceVerification;